





































import { FormStructure } from '@master/model/structure/FormStructure'
import ViewPolicyPlaceHolderSection from '@core/pages/new-business-register/components/policy/ViewPolicyPlaceHolderSection.vue'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import HierarchyDataTable from '@core/pages/hierarchy-setup/components/HierarchyDataTable.vue'
import HierarchyRowView from '@core/pages/hierarchy-setup/components/HierarchyRowView.vue'
import HierarchyCSVUpload from '@core/pages/hierarchy-setup/components/HierarchyCSVUpload.vue'
import { HierarchySetupCsvModel } from '../models/HierarchySetupCsvModel'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import { UIService } from '@core/services/UIService'
import { HierarchySetupDTO, HierarchySetupService } from '@core/pages/hierarchy-setup/api'
import { CommissionRecordsService } from '@core/pages/CommissionModule/api'

const hierarchySetupStore = namespace('HierarchySetupStore')

@Component({
  components: {
    HierarchyDataTable,
    HierarchyRowView,
    HierarchyCSVUpload,
    ViewPolicyPlaceHolderSection
  }
})
export default class HierarchySetupPage extends Vue {
  @inject()
  protected sharedVariable: SharedVariable

  protected uiService: UIService

  @hierarchySetupStore.State
  hierarchySetupRows: HierarchySetupDTO[]

  @hierarchySetupStore.State
  hierarchyInView: HierarchySetupDTO

  @hierarchySetupStore.Action
  selectHierarchyToView

  @hierarchySetupStore.Action
  importHierarchySetup

  @hierarchySetupStore.Action
  fetchHierarchySetup

  tableDisplayColumns: Array<object> = [
    { label: 'AWG Rep Code', field: 'pfpfaRepCode' },
    { label: 'Scheme', field: 'scheme' },
    { label: 'Schedule Name', field: 'scheduleName' },
    { label: 'Name (Name Reflected on MAS System)', field: 'name' },
    { label: 'Reporting Agent (RA) Code 1', field: 'reportingAgentRaCode1' },
    { label: 'Reporting Agent (RA) Name 1', field: 'reportingAgentRaName1' },
    { label: 'Designation', field: 'designation' },
    { label: 'Reporting Agent (RA) Code 2', field: 'reportingAgentRaCode2' },
    { label: 'Reporting Agent (RA) Name 2', field: 'reportingAgentRaName2' },
    { label: 'Status', field: 'status' },
    { label: 'Start Date', field: 'startDateMillis' },
    { label: 'End Date', field: 'endDateMillis' }
  ]

  showImportDialog = false
  showRowDialog = false
  processingImportId = null
  isImporting = false

  async saveCompensationRecord () {
    // eslint-disable-next-line dot-notation
    delete this.hierarchyInView['startDateMillis']

    // eslint-disable-next-line dot-notation
    delete this.hierarchyInView['endDateMillis']

    // eslint-disable-next-line dot-notation
    delete this.hierarchyInView['emit']

    await HierarchySetupService.updateHierarchyRecord(this.hierarchyInView)
    await this.fetchHierarchySetup()
    this.showRowDialog = false
  }

  async exportCSV () {
    try {
      const res = await HierarchySetupService.downloadHierarchyListCsv()
      const blob = new Blob([res], { type: 'text/csv' })
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, 'compensation_setup.csv')
      } else {
        const elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = 'compensation_setup.csv'
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
      }
    } catch (err) {
      alert(err.response.data.message)
    }
  }

  popUpImportDisplay () {
    this.showImportDialog = true
  }

  popUpRowDisplay (selectedRow: HierarchySetupDTO) {
    this.selectHierarchyToView(selectedRow)
    this.showRowDialog = true
  }

  get csvModel () {
    return HierarchySetupCsvModel
  }

  async triggerImportHierarchy (importData: HierarchySetupDTO[]) {
    const id = this.uiService.randomID()
    this.uiService.loading.addLoadingTask(id)
    try {
      const res = await this.importHierarchySetup(importData)
      if (res) {
        this.uiService.alert.show({ type: 'success', message: 'Compensation Setup successfully imported!' })
        this.showImportDialog = false
      } else {
        this.uiService.alert.show({
          type: 'error',
          message: 'Something went wrong while importing CSV.'
        })
      }
    } catch (err) {
      console.error(err)
      this.uiService.alert.show({
        type: 'error',
        message: 'Unable to process import, please contact Administrator.'
      })
    } finally {
      await this.fetchHierarchySetup()
      this.isImporting = false
      this.uiService.loading.removeLoadingTask(id)
    }
  }

  triggerProcessing (value: boolean) {
    if (value) {
      this.processingImportId = this.uiService.randomID()
      this.uiService.loading.addLoadingTask(this.processingImportId)
    } else {
      this.isImporting = false
      this.uiService.loading.removeLoadingTask(this.processingImportId)
    }
  }

  get pfpRepDetailsStructure (): FormStructure<HierarchySetupDTO> {
    return [
      {
        label: 'AWG Rep Code',
        key: 'pfpfaRepCode'
      },
      {
        label: 'Scheme',
        key: 'scheme'
      },
      {
        label: 'Schedule Name',
        key: 'scheduleName'
      },
      {
        label: 'Name (Name Reflected on MAS System)',
        key: 'name'
      },
      {
        label: 'Reporting Agent (RA) Code 1',
        key: 'reportingAgentRaCode1'
      },
      {
        label: 'Reporting Agent (RA) Name 1',
        key: 'reportingAgentRaName1'
      },
      {
        label: 'Designation',
        key: 'designation'
      },
      {
        label: 'Reporting Agent (RA) Code 2',
        key: 'reportingAgentRaCode2'
      },
      {
        label: 'Reporting Agent (RA) Name 2',
        key: 'reportingAgentRaName2'
      },
      {
        label: 'Status',
        key: 'status',
        options: [
          { label: 'Active', value: 'Active' },
          { label: 'Inactive', value: 'Inactive' }
        ]
      },
      {
        label: 'Start Date',
        key: 'startDate',
        type: 'date'
      },
      {
        label: 'End Date',
        key: 'endDate',
        type: 'date'
      }
    ]
  }

  get tier1DetailsStructure (): FormStructure<HierarchySetupDTO> {
    return [
      {
        label: 'Tier 1 RP',
        key: 'tier1SinglifeRp',
        type: 'number'
      },
      {
        label: 'Tier 1 SP',
        key: 'tier1SinglifeSp',
        type: 'number'
      },
      {
        label: 'Tier 1 GI',
        key: 'tier1Gi',
        type: 'number'
      }
    ]
  }

  get tier2DetailsStructure (): FormStructure<HierarchySetupDTO> {
    return [
      {
        label: 'Tier 2 RP',
        key: 'tier2SinglifeRp',
        type: 'number'
      },
      {
        label: 'Tier 2 SP',
        key: 'tier2SinglifeSp',
        type: 'number'
      },
      {
        label: 'Tier 2 GI',
        key: 'tier2Gi',
        type: 'number'
      }
    ]
  }

  get tier3DetailsStructure (): FormStructure<HierarchySetupDTO> {
    return [
      {
        label: 'Tier 3 RP',
        key: 'tier3SinglifeRp',
        type: 'number'
      },
      {
        label: 'Tier 3 SP',
        key: 'tier3SinglifeSp',
        type: 'number'
      }
    ]
  }

  get performanceServiceDetailsStructure (): FormStructure<HierarchySetupDTO> {
    return [
      {
        label: 'Performance Bonus RP',
        key: 'performanceBonusSinglifeRp',
        type: 'number'
      },
      {
        label: 'Company\'s Banding All Ex GI',
        key: 'serviceChargeOthers',
        type: 'number'
      },
      {
        label: 'Company\'s Banding GI',
        key: 'serviceChargeGi',
        type: 'number'
      },
      {
        label: 'Profit Sharing RP',
        key: 'profitSharingRp',
        type: 'number'
      }
    ]
  }

  async mounted () {
    this.uiService = this.sharedVariable.uiService
    await this.fetchHierarchySetup()
  }
}
